/**
 * This singleton keeps the current state of the application.
 */

class State {
  private state: any;

  constructor() {
    this.state = {};
  }

  setValue(key: string, value: any) {
    this.state[key] = Object.assign({ listeners: new Set() }, this.state[key], {
      value,
    });

    this.state[key].listeners.forEach((listener: any) => {
      listener(value);
    });
  }

  getValue(key: string) {
    return this.state[key] && this.state[key].value;
  }

  addListener(key: string, listener: (value: any) => void) {
    if (typeof listener != 'function') {
      console.error(`Listener has to be a function. Got ${typeof listener}`);
      return;
    }

    this.state[key] = Object.assign({ listeners: new Set() }, this.state[key]);
    this.state[key].listeners.add(listener);
  }

  removeListener(key: string, listener?: (value: any) => void) {
    this.state[key] = Object.assign({ listener: new Set() }, this.state[key]);

    if (listener === undefined) {
      this.state[key] = Object.assign({}, this.state[key], {
        listeners: new Set(),
      });
    } else if (this.state[key].listeners && this.state[key].listeners.has(listener)) {
      this.state[key].listeners.delete(listener);
    }
  }

  print() {
    console.log(this.state);
  }
}

const state = new State();
export default state;
